const cleanTitle = (title = "", options = {}) => {
  let newTitle = title?.toString() || "";
  newTitle = newTitle.replace("ONLINE - ", "");
  newTitle = newTitle.replace("[GRATUITO]", "");
  newTitle = newTitle.replace("[COMBO]", "");
  newTitle = newTitle.replace("[CICLO DE MENTORIA]", "");
  newTitle = newTitle.replace("[POWER HACKS]", "");
  newTitle = newTitle.replace("[MASTER CLASS]", "");
  newTitle = newTitle.replace("[LETS GROW]", "");
  newTitle = newTitle.replace("AULA AO VIVO - ", "");
  newTitle = newTitle.replace("[DESMISTIFICANDO]", "");
  newTitle = newTitle.replace("[WORKSHOP]", "");
  newTitle = newTitle.replace(
    " TRUQUES DE EXCEL PARA PROCESSOS SELETIVOS -",
    ""
  );
  newTitle = newTitle.replace(" MARKETING DIGITAL - ", "");
  newTitle = newTitle.replace(" MARKETING DE CONTEÚDO - ", "");
  newTitle = newTitle.replace(" BLACK BELT NA PRÁTICA - ", "");
  newTitle = newTitle.replace(" SCRUM PARA GERENCIAMENTO DE PROJETOS - ", "");
  newTitle = newTitle.replace(" INOVAÇÃO E DESIGN THINKING - ", "");
  newTitle = newTitle.replace(" GESTÃO FINANCEIRA - ", "");
  newTitle = newTitle.replace("[MUNDO EMPREENDEDOR] ", "");
  newTitle = newTitle.replace("[PAPO DE CONSULTOR] ", "");
  newTitle = newTitle.replace("[PAPO DE ESPECIALISTA] ", "");
  newTitle = newTitle.replace("[PASSO A PASSO] ", "");
  newTitle = newTitle.replace("[SOFT SKILLS] ", "");
  newTitle = newTitle.replace("[INDÚSTRIA 4.0] ", "");
  options.removeFormacoes &&
    (newTitle = newTitle.replace("PCP", "Planejamento e Controle da Produção"));
  options.removeFormacoes &&
    (newTitle = newTitle.replace(
      "Formação de Especialistas em  World Class Manufacturing WCM",
      "World Class Manufacturing"
    ));
  options.removeFormacoes && (newTitle = newTitle.replace("Formação em ", ""));
  options.removeFormacoes &&
    (newTitle = newTitle.replace("Formação Empreendedora", "Empreendedorismo"));
  const newTitleArray = newTitle.split("(");
  newTitle = newTitleArray[0];
  return newTitle;
};

export default cleanTitle;
